import React, { useCallback } from 'react';
import { useGetUsersRewardsDataMutation } from "../../slices/adminApiSlice";
import AdminAddReward from '../../components/AdminComponents/AdminAddReward';
import AdminRewardTable from '../../components/AdminComponents/AdminRewardTable';

const AdminRewardsManagerScreen = () => {
    const [getRewardsData] = useGetUsersRewardsDataMutation();

    const fetchRewards = useCallback(async () => {
        try {
            await getRewardsData().unwrap();
        } catch (error) {
            // console.error('Error fetching rewards:', error);
        }
    }, [getRewardsData]);

    return (
        <AdminRewardTable fetchRewards={fetchRewards}>
            <AdminAddReward fetchRewards={fetchRewards} />
        </AdminRewardTable>
    );
};

export default AdminRewardsManagerScreen;
